import React from 'react'

import "animate.css/animate.min.css";

import { FaHome} from "react-icons/fa";


const CompanyCorporateTableSmallFormat = (props) => {
    return (
        <tr class="largeCell">
            <td class="bigfont">
                {props.name}
            </td>
            {/* <td className="">
                <div className='object-fill p-6 lg:p-12 w-64 lg:w-80 inline-block'>
                    <img className="w-full h-full" src={props.img}></img>
                </div>
            </td> */}
            <td class="leftAlign">
                <div style={{padding:"4px"}}>
                {props.info}
                </div>
            </td>
            <td class="leftAlign">
                <div style={{padding:"4px"}}>
                {props.prod}
                </div>
            </td>
            <td>
                <a href={props.link}>
                    <div className='exhibitor-comp-corp-icon-wrap'>
                        <FaHome size="30px"/>
                    </div>
                </a>
            </td>
        </tr>
    )
  }

  export default CompanyCorporateTableSmallFormat